export const getCroppedImg = (imageSrc, crop, imageDimensions) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;

      const cropPx = {
        x: (crop.x / 100) * imageDimensions.width,
        y: (crop.y / 100) * imageDimensions.height,
        width: (crop.width / 100) * imageDimensions.width,
        height: (crop.height / 100) * imageDimensions.height,
      };

      cropPx.x = Math.max(
        0,
        Math.min(cropPx.x, imageDimensions.width - cropPx.width)
      );
      cropPx.y = Math.max(
        0,
        Math.min(cropPx.y, imageDimensions.height - cropPx.height)
      );
      cropPx.width = Math.min(cropPx.width, imageDimensions.width - cropPx.x);
      cropPx.height = Math.min(
        cropPx.height,
        imageDimensions.height - cropPx.y
      );
      canvas.width = cropPx.width;
      canvas.height = cropPx.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        cropPx.x * scaleX,
        cropPx.y * scaleY,
        cropPx.width * scaleX,
        cropPx.height * scaleY,
        0,
        0,
        cropPx.width,
        cropPx.height
      );

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Canvas is empty"));
          }
        },
        "image/jpeg",
        1
      );
    };
    image.onerror = (error) => {
      console.error("Image failed to load:", error);
      reject(error);
    };
  });
};
